import React from 'react';

const ArtStyleSelector = ({ currentStyle = 'random', onStyleChange }) => {
    const artStyles = [
        { id: 'random', icon: '🎲', label: 'Random' },
        { id: 'expression', icon: '🎭', label: 'Expression' },
        { id: 'abstract', icon: '🌀', label: 'Abstract' },
        { id: 'surreal', icon: '🌌', label: 'Surreal' },
        { id: 'naive', icon: '🎡', label: 'Naïve' },
        { id: 'minimal', icon: '◽', label: 'Minimal' },
        { id: 'anime', icon: '🌸', label: 'Anime' },
        { id: 'ink', icon: '🖋️', label: 'Ink' }
    ];

    const handleStyleClick = (styleId) => {
        console.log('Style clicked:', styleId, 'Current style:', currentStyle);
        if (styleId !== currentStyle) {
            onStyleChange(styleId);
        }
    };

    return (
        <div className="art-style-selector">
            <h3 className="section-title">Pick an art style</h3>
            <div className="art-style-grid">
                {artStyles.map(style => (
                    <button
                        key={style.id}
                        className={`art-style-card ${currentStyle === style.id ? 'active' : ''}`}
                        onClick={() => handleStyleClick(style.id)}
                        type="button"
                    >
                        <div className="style-icon-container">
                            <span className="style-icon">{style.icon}</span>
                            {currentStyle === style.id && (
                                <div className="style-sparkles">
                                    <span>✨</span>
                                    <span>✨</span>
                                    <span>✨</span>
                                </div>
                            )}
                        </div>
                        <span className="style-label">{style.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default ArtStyleSelector; 